import BaseServiceCrud from './BaseServiceCrud';

export default class GroupService extends BaseServiceCrud {
    // Initializing important variables
    constructor() {
        super();
        this.path = 'bo-group';
    }

    getCriteria(criteria) {
        return this.objToQueryString({
            text: criteria.name,
            id: criteria.id,
            first_result: criteria.firstResult,
            max_result: criteria.maxResults,
            sort_field: criteria.sortField,
            sort_asc: criteria.sortAsc,
        });
    }

    add(request) {
        // Get a token from api server using the fetch api
        return this.fetch(`${this.domain}/${this.path}/`, {
            method: 'POST',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
    getGroups(criteria) {
        const queryString = this.getCriteria(criteria);
        return this.fetch(`${this.domain}/${this.path}/list${queryString}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    getGroupsUsers(groupId) {
        return this.fetch(`${this.domain}/${this.path}/${groupId}`, {
            method: 'GET',
        }).then((res) => {
            return Promise.resolve(res);
        });
    }

    updateGroupAndAssignUsers(id, request) {
        return this.fetch(`${this.domain}/${this.path}/users-assignment/${id}`, {
            method: 'PUT',
            body: JSON.stringify(request),
        }).then((res) => {
            return Promise.resolve(res);
        });
    }
}
